export class SetAnonymous {
  static readonly type = '[OptIns] Set Anonymous';
  constructor(public payload: boolean) {}
}

export class SetAnonymousAndFundraiser {
  static readonly type = '[OptIns] Set Anonymous And Fundraiser';
  constructor(public payload: { anonymous: boolean, showForFundraiser: boolean }) {}
}

export class SetEmails {
  static readonly type = '[OptIns] Set Emails';
  constructor(public payload: boolean) {}
}

export class SetPayFee {
  static readonly type = '[OptIns] Set PayFee';
  constructor(public payload: { enabled: boolean; amount: number }) {}
}
